import {DefineOpenSansFont} from './fonts/openssans';

export function DefineFonts() {
  DefineOpenSansFont();
}
